module.exports = __webpack_public_path__ + "static/media/radiscan-logo.776ea977.png";